import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

//styles
import { Asterisk, Label } from './index.styled';

const FormLabel = ({ name, label, error, isRequired, disabled, margin }) => {
  const { t } = useTranslation();

  return (
    <Label label={label} htmlFor={name} error={error} disabled={disabled} margin={margin}>
      {isRequired && <Asterisk disabled={disabled}>*</Asterisk>} {t(label)}
    </Label>
  );
};

FormLabel.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.any,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  margin: PropTypes.string,
};

export default FormLabel;
